import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {AdService} from '@services/ad.service';
import {Title} from '@angular/platform-browser';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-url',
  templateUrl: './url.component.html',
  styleUrls: ['./url.component.scss']
})
export class UrlComponent implements OnInit {
    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tabs: Tab[] = [];
    tab: Tab;
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    currentUser = null;
    params;

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private adService: AdService,
        private titleService: Title,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.titleService.setTitle('LyBox - Anaylyse de lien');
        this.favorite = this.adService.getEmptyFavorite();

        this.favorite.agence = 0;
        this.favorite.amount_rent_insurance = 0;
        this.favorite.apport = 0;
        this.favorite.banking_fees = 0;

        this.route.data.subscribe(data => {
            this.tabs = data.tabs;
            this.tab = data.tab;
        });
    }

    updateAd() {
    }
}
